import React from 'react';

import { useIntl } from '@utils/intl';
import { BookingIcon } from '@views/shared/BookingIcon';
import { BOOK_CATEGORY_HOME, getBookingIcon } from '@views/shared/consts';
import { useGoTo } from '@views/shared/utils/useGoTo';
import { Panel } from '@views/Book/Bookings/Panel';

export default function HomeOffice() {
  const { t } = useIntl();

  const { goToBookingPage } = useGoTo();

  return (
    <Panel
      icon={<BookingIcon name={getBookingIcon(BOOK_CATEGORY_HOME)} />}
      name={t('Home.Bookings.HomeOffice.title')}
      onAction={() => goToBookingPage({ type: BOOK_CATEGORY_HOME })}
    />
  );
}
